<main class="approval-page">
  <section class="filters panel">
    <label
      >QCA <b>*</b
      ><select [value]="qca()" (change)="qca.set($any($event.target).value)">
        <option>Maharashtra Solar QCA (QCA-01)</option>
      </select></label
    >
    <label
      >Generating Company<select
        [value]="company()"
        (change)="company.set($any($event.target).value)"
      >
        <option>All</option>
        <option>SunPower Energy Pvt. Ltd.</option>
        <option>WindStar Renewables Ltd.</option>
        <option>Green Hybrid Pvt. Ltd.</option>
        <option>Maha Wind Energy Pvt. Ltd.</option>
      </select></label
    >
    <label
      >Generating Unit<select
        [value]="unit()"
        (change)="unit.set($any($event.target).value)"
      >
        <option>All</option>
        @for (row of submissions(); track row.unit) {
          <option [value]="row.unit">{{ row.unit }}</option>
        }
      </select></label
    >
    <label
      >Contract<select
        [value]="contract()"
        (change)="contract.set($any($event.target).value)"
      >
        <option>All</option>
        @for (row of submissions(); track row.contract) {
          <option [value]="row.contract">{{ row.contract }}</option>
        }
      </select></label
    >
    <label
      >Schedule Type<select
        [value]="scheduleType()"
        (change)="scheduleType.set($any($event.target).value)"
      >
        <option>All</option>
        <option>Day Ahead</option>
        <option>Intra Day</option>
        <option>Week Ahead</option>
      </select></label
    >
    <label
      >Schedule Date<input
        type="date"
        [value]="scheduleDate()"
        (change)="scheduleDate.set($any($event.target).value)"
    /></label>
    <label
      >Submission Date<input
        type="date"
        [value]="submissionDate()"
        (change)="submissionDate.set($any($event.target).value)"
    /></label>
    <label
      >Status<select
        [value]="status()"
        (change)="status.set($any($event.target).value)"
      >
        <option>All</option>
        <option>Pending</option>
        <option>Approved</option>
        <option>Rejected</option>
      </select></label
    >
    <div class="filter-actions">
      <button class="search" (click)="search()">⌕&nbsp; Search</button
      ><button class="reset" (click)="reset()">Reset</button>
    </div>
  </section>

  <section class="stats panel">
    <article class="submitted">
      <i>▣</i>
      <div>
        <span>Total Submitted</span><strong>{{ submissions().length }}</strong>
      </div>
    </article>
    <article class="pending">
      <i>♧</i>
      <div>
        <span>Pending</span><strong>{{ pendingCount() }}</strong>
      </div>
    </article>
    <article class="approved">
      <i>♙</i>
      <div>
        <span>Approved</span><strong>{{ approvedCount() }}</strong>
      </div>
    </article>
    <article class="rejected">
      <i>♧</i>
      <div>
        <span>Rejected</span><strong>{{ rejectedCount() }}</strong>
      </div>
    </article>
    <article class="capacity">
      <i>♜</i>
      <div>
        <span>Total Capacity (MW)</span
        ><strong>{{ totalCapacity() | number: "1.2-2" }}</strong>
      </div>
    </article>
    <article class="energy">
      <i>⌁</i>
      <div>
        <span>Total Energy (MWh)</span
        ><strong>{{ totalEnergy() | number: "1.2-2" }}</strong>
      </div>
    </article>
  </section>

  <section class="table-panel panel">
    <header>
      <h1>Schedules Pending for Approval</h1>
      <div class="table-tools">
        @if (selected().size>1) {
          <span>{{ selected().size }} selected</span
          ><button class="bulk-approve" (click)="setSelectedStatus('Approved')">
            ✓&nbsp; All Approve</button
          ><button class="bulk-reject" (click)="setSelectedStatus('Rejected')">
            ✕&nbsp; All Reject
          </button>
        }
        <button class="export" (click)="exportCsv()">⇩&nbsp; Export⌄</button>
      </div>
    </header>
    <div class="table-wrap">
      <table class="qca-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                [checked]="allVisibleSelected()"
                (change)="toggleVisible($any($event.target).checked)"
              />
            </th>
            <th>#</th>
            <th>Generating Company</th>
            <th>Generating Unit</th>
            <th>Contract No.</th>
            <th>Consumer / Utility</th>
            <th>Schedule Type</th>
            <th>Schedule Date</th>
            <th>Revision No.</th>
            <th>Capacity (MW)</th>
            <th>Final Implemented<br />Energy (MWh)</th>
          
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (row of visibleRows(); track row.id) {
            <tr>
              <td>
                <input
                  type="checkbox"
                  [checked]="selected().has(row.id)"
                  (change)="toggle(row.id, $any($event.target).checked)"
                />
              </td>
              <td>{{ row.id }}</td>
              <td>{{ row.company }}</td>
              <td>{{ row.unit }}</td>
              <td>{{ row.contract }}</td>
              <td>{{ row.consumer }}</td>
              <td>{{ row.scheduleType }}</td>
              <td>{{ row.scheduleDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ row.revision }}</td>
              <td>{{ row.capacity | number: "1.2-2" }}</td>
              <td>{{ row.energy | number: "1.2-2" }}</td>

              <td>
                <span class="status" [class]="row.status.toLowerCase()">{{
                  row.status
                }}</span>
              </td>
              <td class="actions">
                @if (row.status === "Pending") {
                  <button
                    class="approve"
                    (click)="requestStatusChange([row.id], 'Approved')"
                    [disabled]="selected().has(row.id)"
                  >
                    Approve</button
                  ><button
                    class="reject"
                    (click)="requestStatusChange([row.id], 'Rejected')"
                    [disabled]="selected().has(row.id)"
                  >
                    Reject
                  </button>
                } @else {
                  <button class="view" [disabled]="selected().has(row.id)" (click)="viewDetails(row.id)">View</button>
                }
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="15" class="empty">No schedule submissions found.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <footer class="table-footer">
      <span
        >Showing {{ filtered().length ? (page() - 1) * pageSize + 1 : 0 }} to
        {{ Math.min(page() * pageSize, filtered().length) }} of
        {{ filtered().length }} entries</span
      >
      <div class="pagination">
        <button
          type="button"
          class="page-button"
          (click)="changePage(page() - 1)"
          [disabled]="page() === 1"
        >
          ‹
        </button>
        @for (pageNumber of pageNumbers(); track pageNumber) {
          <button
            type="button"
            class="page-button"
            [class.active]="pageNumber === page()"
            (click)="changePage(pageNumber)"
          >
            {{ pageNumber }}
          </button>
        }
        <button
          type="button"
          class="page-button"
          (click)="changePage(page() + 1)"
          [disabled]="page() === totalPages()"
        >
          ›
        </button>
      </div>
    </footer>
  </section>
  @if (pendingAction(); as action) {
    <div class="modal-backdrop" role="presentation">
      <section class="confirmation-modal" role="dialog" aria-modal="true" aria-labelledby="confirmation-title">
        <h2 id="confirmation-title">Confirm {{ action.status }}</h2>
        <p>Are you sure you want to {{ action.status.toLowerCase() }} {{ action.ids.length }} schedule{{ action.ids.length === 1 ? '' : 's' }}?</p>
        <div class="modal-actions"><button class="cancel" (click)="cancelStatusChange()">Cancel</button><button class="confirm" [class.reject-confirm]="action.status === 'Rejected'" (click)="confirmStatusChange()">Confirm {{ action.status }}</button></div>
      </section>
    </div>
  }
</main>
